import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { AppStorageService } from '../share/appstorage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ChangesService } from '../share/changes.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../auth/auth.service';
import { AppSettings } from '../../settings';
import { Languages } from '../share/languages.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
private _subscription: Subscription;
saldo: number;
_timer: Observable<number>;
timerSubscription: Subscription;
isAdmin: boolean;
isBetshop: boolean;
isOther:boolean;
partnerName: string;
username: string;
currencySuffix: string;
isOpen = false;

public status: { isopen: boolean } = { isopen: false };
languages: Languages[] = [];
currentLanguageName: string;

  constructor(
    public translateService: TranslateService,
    private _storage: AppStorageService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _authService: AuthService,
    private _changesService: ChangesService,
    private _settings: AppSettings
  ) {
    this.isAdmin = _storage.getIsAdmin() === 'true';
    this.isBetshop = _storage.getIsBetshopUser() === 'true';
    this.isOther = _storage.getIsOtherUser() === 'true';

      this._timer = Observable.timer(10, 10000);
      this.currencySuffix = _settings.defaultCurrencySuffix;

      const currentLanguage = _storage.getAppsLang();

      this.languages.push({name: 'English', value: 'en', code: 'en-EN'});
      this.languages.push({name: 'Croatian', value: 'hr', code: 'hr-HR'});

      this.currentLanguageName = this.languages.find(x => x.value === currentLanguage).name;

      this.isBetshop = _storage.getIsBetshopUser() === 'true';
    }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this._subscription !== undefined) {
      this._subscription.unsubscribe();
      this.timerSubscription.unsubscribe();
    }
  }

  public dropdownToggle($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  changeLanguage(language: Languages) {
    this._storage.setAppsLang(language.value);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translateService.use(language.value);

    this.currentLanguageName = this.languages.find(x => x.value === this._storage.getAppsLang()).name;
    this.isOpen = false;
  }

  showBack() {
     return this._storage.getBackUrl() != null;
  }

  goBack() {
    this._router.navigate([this._storage.getBackUrl()], { relativeTo: this._route });
  }

}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/header/header.component.ts